import { render, staticRenderFns } from "./DialogBookList.vue?vue&type=template&id=11621684&scoped=true"
import script from "./DialogBookList.vue?vue&type=script&lang=js"
export * from "./DialogBookList.vue?vue&type=script&lang=js"
import style0 from "./DialogBookList.vue?vue&type=style&index=0&id=11621684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11621684",
  null
  
)

export default component.exports